var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography, Box } from "@mui/material";
export var Description = function (_a) {
    var description = _a.description, action = _a.action;
    if (description) {
        return (_jsxs(Box, __assign({ sx: { py: 3 } }, { children: [_jsx(Typography, __assign({ variant: "subtitle2", color: "text.secondary", onClick: function () { return action === null || action === void 0 ? void 0 : action(); }, sx: {
                        display: "inline",
                        cursor: "pointer",
                        "&:hover": {
                            textDecoration: "underline",
                        },
                    } }, { children: description })), _jsx(Typography, __assign({ variant: "body2", onClick: function () { return action === null || action === void 0 ? void 0 : action(); }, sx: {
                        wordBreak: "break-word",
                        cursor: "pointer",
                        position: "relative",
                        fontSize: 10,
                        top: -5,
                    }, color: "text.secondary", component: "span" }, { children: "( i )" }))] })));
    }
    return null;
};
